import CoBorrowers from "./CoBorrowers";

export const loanOnboardingArr = (tinType = 0) => {
  return [
    {
      field: "Borrowers",
      arr: [
        {
          section: "Borrowers",
          subArr: [
            {
              subArrtitle: "Primary Borrower",
              subArrarr: [
                {
                  section: "Name & Salutation",
                  className: "col-6",
                  arr: [
                    {
                      title: "Name",
                      field: "FullName",
                      type: "text",
                      className: "col-12",
                    },
                    {
                      title: "Salutation",
                      field: "Salutation",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "First Name",
                      field: "FirstName",
                      type: "text",
                      className: "col-8",
                    },
                    {
                      title: "Last Name",
                      field: "LastName",
                      type: "text",
                      className: "col-8",
                    },
                    {
                      title: "M.I.",
                      field: "MI",
                      type: "text",
                      className: "col-4",
                    },
                  ],
                },
                {
                  section: "Phone Numbers",
                  className: "col-6",
                  arr: [
                    {
                      title: "Home",
                      field: "PhoneHome",
                      type: "phoneNumber",
                      className: "col-12",
                    },
                    {
                      title: "Work",
                      field: "PhoneWork",
                      type: "phoneNumber",
                      className: "col-12",
                    },
                    {
                      title: "Mobile",
                      field: "PhoneCell",
                      type: "phoneNumber",
                      className: "col-12",
                    },
                    {
                      title: "Fax",
                      field: "PhoneFax",
                      type: "phoneNumber",
                      className: "col-12",
                    },
                  ],
                },
                {
                  section: "Mailing Address",
                  className: "col-6",
                  arr: [
                    {
                      title: "Street",
                      field: "Street",
                      type: "text",
                      className: "col-12",
                    },
                    {
                      title: "City",
                      field: "City",
                      type: "text",
                      className: "col-12",
                    },
                    {
                      title: "State",
                      field: "State",
                      type: "text",
                      className: "col-6",
                    },
                    {
                      title: "Zip Code",
                      field: "ZipCode",
                      type: "text",
                      className: "col-6",
                    },
                  ],
                },
                {
                  section: "Account Information",
                  className: "col-6",
                  arr: [
                    {
                      title: "Account",
                      field: "Account",
                      type: "text",
                      className: "col-12",
                    },
                    {
                      title: "TIN",
                      field: "TIN",
                      type: "pattern",
                      className: "col-12",
                      pattern:
                        tinType === 0
                          ? "000000000"
                          : tinType === 2
                          ? "000-00-0000"
                          : "12-3456789",
                    },
                    {
                      title: "TIN Type",
                      field: "TINType",
                      type: "select",
                      className: "col-12",
                      options: [
                        { label: "0-Unknown", value: 0 },
                        { label: "2-SSN", value: 2 },
                        { label: "1-EIN", value: 3 },
                      ],
                    },
                    {
                      title: "Hold",
                      field: "Hold",
                      type: "checkbox",
                      className: "col-12",
                    },
                  ],
                },
                {
                  section: "GeoMap Information",
                  className: "col-6",
                  arr: [
                    {
                      title: "Latitude",
                      field: "Latitude",
                      type: "text",
                      className: "col-12",
                    },
                    {
                      title: "Longitude",
                      field: "Longitude",
                      type: "text",
                      className: "col-12",
                    },
                  ],
                },

                {
                  section: "Notices & Forms",
                  className: "col-6",
                  arr: [
                    {
                      title: "Send Late Notices",
                      field: "sendLateNotices",
                      type: "checkbox",
                      className: "col-12",
                    },
                    {
                      title: "Send Payment Receipts",
                      field: "sendPaymentReceipts",
                      type: "checkbox",
                      className: "col-12",
                    },
                    {
                      title: "Send Payment Statements",
                      field: "sendPaymentStatements",
                      type: "checkbox",
                      className: "col-12",
                    },
                    {
                      title: "Print Rolodex Cards",
                      field: "printRolodexCards",
                      type: "checkbox",
                      className: "col-12",
                    },
                  ],
                },

                {
                  section: "E-mail & Delivery Options",
                  className: "col-6",
                  arr: [
                    {
                      title: "E-mail",
                      field: "EmailAddress",
                      type: "text",
                      className: "col-12",
                    },
                    {
                      content: "Delivery",
                      type: "content",
                      className: "fw-bold col-12",
                    },
                    {
                      title: "Print",
                      field: "Print",
                      type: "checkbox",
                      className: "col-4",
                    },
                    {
                      title: "Email",
                      field: "Email",
                      type: "checkbox",
                      className: "col-4",
                    },
                    {
                      title: "Text Message",
                      field: "TextMessage",
                      type: "checkbox",
                      className: "col-4",
                    },
                  ],
                },
              ],
            },
            {
              subArrtitle: "Co-Borrowers",
              subArrarr: [
                // {
                //   section: "",
                //   arr: [
                //     {
                //       title: "First Name",
                //       field: "firstName",
                //       type: "text",
                //       className: "col-4",
                //     },
                //     {
                //       title: "Middle Name",
                //       field: "middleName",
                //       type: "text",
                //       className: "col-4",
                //     },
                //     {
                //       title: "Last Name",
                //       field: "lastName",
                //       type: "text",
                //       className: "col-4",
                //     },
                //     {
                //       title: "Sort Name",
                //       field: "sortName",
                //       type: "text",
                //       className: "col-4",
                //     },
                //     {
                //       title: "By Last Name",
                //       field: "byLastName",
                //       type: "text",
                //       className: "col-4",
                //     },
                //     {
                //       title: "Full Name",
                //       field: "fullName",
                //       type: "text",
                //       className: "col-4",
                //     },
                //     {
                //       title: "Salutation",
                //       field: "salutation",
                //       type: "text",
                //       className: "col-4",
                //     },
                //     {
                //       title: "Street",
                //       field: "street",
                //       type: "text",
                //       className: "col-4",
                //     },
                //     {
                //       title: "City",
                //       field: "city",
                //       type: "text",
                //       className: "col-4",
                //     },
                //     {
                //       title: "State",
                //       field: "state",
                //       type: "text",
                //       className: "col-4",
                //     },
                //     {
                //       title: "Zipcode",
                //       field: "zipcode",
                //       type: "text",
                //       className: "col-4",
                //     },
                //     {
                //       title: "Phone (Home)",
                //       field: "phoneHome",
                //       type: "text",
                //       className: "col-4",
                //     },
                //     {
                //       title: "Phone (Work)",
                //       field: "phoneWork",
                //       type: "text",
                //       className: "col-4",
                //     },
                //     {
                //       title: "Phone (Cell)",
                //       field: "phoneCell",
                //       type: "text",
                //       className: "col-4",
                //     },
                //     {
                //       title: "Fax",
                //       field: "fax",
                //       type: "text",
                //       className: "col-4",
                //     },
                //     {
                //       title: "Phone (Main)",
                //       field: "phoneMain",
                //       type: "text",
                //       className: "col-4",
                //     },
                //     {
                //       title: "Tin",
                //       field: "tin",
                //       type: "text",
                //       className: "col-4",
                //     },
                //     {
                //       title: "Email",
                //       field: "email",
                //       type: "text",
                //       className: "col-4",
                //     },
                //   ],
                // },
                {
                  section: "",
                  arr: [
                    {
                      content: <CoBorrowers />,
                      type: "content",
                      className: "col-12",
                    },
                  ],
                },
              ],
            },
            {
              subArrtitle: "ACH",
              subArrarr: [
                {
                  section: "",
                  arr: [
                    {
                      title: "Bank Name",
                      field: "bankName",
                      type: "text",
                      className: "col-6",
                    },
                    {
                      title: "Bank Address",
                      field: "bankAddress",
                      type: "textarea",
                      className: "col-6",
                    },
                    {
                      title: "Routing Number",
                      field: "routingNumber",
                      type: "text",
                      className: "col-6",
                    },
                    {
                      title: "Account Number",
                      field: "accountNumber",
                      type: "text",
                      className: "col-6",
                    },
                    {
                      title: "Individual ID",
                      field: "individualId",
                      type: "text",
                      className: "col-6",
                    },
                    {
                      title: "Individual Name",
                      field: "individualName",
                      type: "text",
                      className: "col-6",
                    },
                    {
                      title: "Account Type",
                      field: "accountType",
                      type: "select",
                      options: [
                        { value: "Checking", label: "Checking" },
                        { value: "Savings", label: "Savings" },
                        {
                          value: "GL Deposite (Credit)",
                          label: "GL Deposite (Credit)",
                        },
                      ],
                      className: "col-6",
                    },
                    {
                      title: "Service Status",
                      field: "serviceStatus",
                      type: "select",
                      options: [
                        { value: "None", label: "None" },
                        { value: "Active", label: "Active" },
                        { value: "Inactive", label: "Inactive" },
                        { value: "Hold", label: "Hold" },
                      ],
                      className: "col-6",
                    },
                    {
                      title: "Apply Debit As",
                      field: "applyDebitAs",
                      type: "select",
                      options: [
                        { value: "Regular Payment", label: "Regular Payment" },
                        {
                          value: "To Trust",
                          label: "To Trust",
                        },
                      ],
                      className: "col-6",
                    },
                    {
                      title: "Debit Frequency",
                      field: "debitFrequency",
                      type: "select",
                      options: [
                        { value: "Once Only", label: "Once Only" },
                        { value: "Monthly", label: "Monthly" },
                        { value: "15th & EOM", label: "15th & EOM" },
                        { value: "Every 15 days", label: "Every 15 days" },
                        { value: "Twice A Month", label: "Twice A Month" },
                        { value: "Semi Yearly", label: "Semi Yearly" },
                        { value: "Bi-Monthly", label: "Bi-Monthly" },
                        { value: "Bi-Weekly", label: "Bi-Weekly" },
                        { value: "Quartly", label: "Quartly" },
                        { value: "Weekly", label: "Weekly" },
                        { value: "Yearly", label: "Yearly" },
                      ],
                      className: "col-6",
                    },
                    {
                      title: "Stop Date",
                      field: "stopDate",
                      type: "date",
                      className: "col-6",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      field: "Properties",
      arr: [
        {
          section: "Properties",
          subArr: [
            {
              subArrtitle: "Properties",
              subArrarr: [],
            },
          ],
        },
      ],
    },
    {
      field: "Funding",
      arr: [
        {
          section: "Funding",
        },
      ],
    },

    {
      field: "Terms",
      arr: [
        {
          section: "Terms",
          subArr: [
            {
              subArrtitle: "General",
              subArrarr: [
                {
                  section: "General",
                  className: "col-6",
                  arr: [
                    {
                      title: "Original Balance",
                      field: "general_General_originalBalance",
                      type: "text",
                      className: "col-12",
                    },
                    {
                      title: "Note Rate",
                      field: "general_General_noteRate",
                      type: "text",
                      className: "col-12",
                    },
                    {
                      title: "Sold Rate",
                      field: "general_General_soldRate",
                      type: "text",
                      className: "col-12",
                    },
                    {
                      title: "Priority",
                      field: "general_General_priority",
                      type: "select",
                      className: "col-12",
                      options: [
                        { label: "1st", value: "0" },
                        { label: "2nd", value: "1" },
                        { label: "3rd", value: "2" },
                        { label: "4th", value: "3" },
                        { label: "5th", value: "4" },
                        { label: "6th", value: "5" },
                        { label: "7th", value: "6" },
                        { label: "8th", value: "7" },
                        { label: "Other", value: "8" },
                      ],
                    },
                  ],
                },
                {
                  section: "Loan Balances",
                  className: "col-6",
                  arr: [
                    {
                      title: "Principal Balance",
                      type: "text",
                      field: "principalBalance",
                      className: "col-12",
                    },
                    {
                      title: "Unpaid Late Charges",
                      type: "text",
                      field: "unpaidLateCharges",
                      className: "col-12",
                    },
                    {
                      title: "Unpaid Interest",
                      type: "text",
                      field: "unpaidInterest",
                      className: "col-12",
                    },
                  ],
                },
                {
                  section: "Unearned Discount / Fees",
                  className: "col-6",
                  arr: [
                    {
                      title: "Accrual Method",
                      field: "P76_ACCRUALMETHOD",
                      type: "select",
                      className: "col-12",
                      options: [
                        { label: "None", value: "0" },
                        { label: "Discount Ratio", value: "1" },
                        { label: "Remaining Term", value: "2" },
                        { label: "At Maturity", value: "3" },
                      ],
                      defaultValue: "0",
                    },
                  ],
                },
                {
                  section: "Payment Frequency",
                  className: "col-6",
                  arr: [
                    {
                      title: "Frequency",
                      field: "P76_PMTFREQ",
                      type: "select",
                      className: "col-12",
                      options: [
                        { label: "Once Only", value: "0" },
                        { label: "Monthly", value: "1" },
                        { label: "Yearly", value: "10" },
                        { label: "Quartly", value: "2" },
                        { label: "Bi-Monthly", value: "3" },
                        { label: "Bi-Weekly", value: "4" },
                        { label: "Weekly", value: "5" },
                        { label: "Every 15 days", value: "6" },
                        { label: "Twice A Month", value: "7" },
                        { label: "15th & EOM", value: "8" },
                        { label: "Semi Yearly", value: "9" },
                      ],
                    },
                    // {
                    //   title: "Due Day",
                    //   field: "P76_DUEDAY",
                    //   type: "text",
                    //   className: "col-12",
                    // },
                  ],
                },
                {
                  section: "Important Dates",
                  className: "col-6",
                  arr: [
                    {
                      title: "Closing",
                      field: "P76_CLOSINGDATE",
                      type: "date",
                      className: "col-12",
                    },
                    {
                      title: "First Payment Date",
                      field: "P76_FIRSTPAYMENTDATE",
                      type: "date",
                      className: "col-12",
                    },
                    {
                      title: "Purchase",
                      field: "P76_PURCHASEDATE",
                      type: "date",
                      className: "col-12",
                    },
                    // {
                    //   title: "Booking",
                    //   field: "P76_BOOKINGDATE",
                    //   type: "date",
                    //   className: "col-12",
                    // },
                    {
                      title: "Next Payment",
                      field: "P76_NEXTDUEDATE",
                      type: "date",
                      className: "col-12",
                    },
                    // {
                    //   title: "Next Revision",
                    //   field: "P76_NEXTREVISION",
                    //   type: "date",
                    //   className: "col-12",
                    // },
                    {
                      title: "Maturity",
                      field: "P76_MATURITYDATE",
                      type: "date",
                      className: "col-12",
                    },
                    {
                      title: "Paid Off",
                      field: "P76_PAIDOFFDATE",
                      type: "date",
                      className: "col-12",
                    },
                  ],
                },
                {
                  section: "Regular Payment",
                  className: "col-6",
                  arr: [
                    {
                      title: "P & I",
                      field: "P76_PMTPI",
                      type: "text",
                      className: "col-12",
                    },
                    {
                      title: "Reserve",
                      field: "P76_PMTRESERVE",
                      type: "text",
                      className: "col-12",
                    },
                    {
                      title: "Impound",
                      field: "P76_PMTIMPOUND",
                      type: "text",
                      className: "col-12",
                    },
                  ],
                },
              ],
            },
            {
              subArrtitle: "Details",
              subArrarr: [
                {
                  section: "Categories & Grouping",
                  className: "col-6",
                  arr: [
                    {
                      title: "Loan Code",
                      field: "P76_LOANCODE",
                      type: "text",
                      className: "col-12",
                    },
                    {
                      title: "Loan Officer",
                      field: "P76_LOANOFFICER",
                      type: "text",
                      className: "col-12",
                    },
                    {
                      title: "Categories",
                      field: "P76_CATEGORIES",
                      type: "textarea",
                      className: "col-12",
                    },
                  ],
                },
                {
                  section: "Escrow Analysis",
                  className: "col-6",
                  arr: [
                    {
                      title: "Next Computation Period",
                      field: "P76_ESCROWSTATEMENTNEXT",
                      type: "date",
                      className: "col-12",
                    },
                  ],
                },
                {
                  section: "Other Loan Details",
                  className: "col-6",
                  arr: [
                    {
                      title: "Loan Purpose",
                      field: "P76_LOANPURPOSE",
                      type: "select",
                      className: "col-12",
                      options: [
                        {
                          value: "CashOutDebtConsolidation",
                          label: "Cash Out/Debt Consolidation",
                        },
                        {
                          value: "CashOutHomeImprovement",
                          label: "Cash Out/Home Improvement",
                        },
                        { value: "CashOutOther", label: "Cash Out/Other" },
                        {
                          value: "LimitedCashOutRateAndTerm",
                          label: "Limited Cash Out/Rate & Term",
                        },
                        { value: "CashOutRefi", label: "Cash-Out Refi" },
                        { value: "Construction", label: "Construction" },
                        {
                          value: "ConstructionPerm",
                          label: "Construction-Perm",
                        },
                        {
                          value: "DebtConsolidation",
                          label: "Debt Consolidation",
                        },
                        { value: "HomeImprovement", label: "Home Improvement" },
                        { value: "NoCashOutRefi", label: "No Cash-Out Refi" },
                        { value: "Other", label: "Other" },
                        { value: "Purchase", label: "Purchase" },
                      ],
                    },
                    {
                      title: "Documentation",
                      field: "P76_DOCUMENTATION",
                      type: "select",
                      className: "col-12",
                      options: [
                        { value: "Alternate", label: "Alternate" },
                        { value: "Full", label: "Full" },
                        { value: "Stated", label: "Stated" },
                      ],
                    },
                    {
                      title: "FICO Score",
                      field: "P76_FICO",
                      type: "text",
                      className: "col-12",
                    },
                    {
                      title: "Section 32",
                      field: "P76_SECTION32",
                      type: "checkbox",
                      className: "col-6",
                    },
                    {
                      title: "Article 7",
                      field: "P76_ARTICLE7",
                      type: "checkbox",
                      className: "col-6",
                    },
                    {
                      title: "Section 4970",
                      field: "P76_SECTION4970",
                      type: "checkbox",
                      className: "col-6",
                    },
                    {
                      title: "RESPA",
                      field: "P76_RESPA",
                      type: "checkbox",
                      className: "col-6",
                    },
                  ],
                },
                {
                  section: "Tax Reporting Information",
                  className: "col-6",
                  arr: [
                    {
                      title: "IRS 1098 Points Paid",
                      field: "P76_SEND1098",
                      type: "text",
                      className: "col-12",
                    },
                  ],
                },
              ],
            },

            {
              subArrtitle: "Construction",
              subArrarr: [
                {
                  section: "Construction",
                  subArr: [
                    {
                      subArrtitle: "Project",
                      subArrarr: [
                        {
                          section: "General",
                          className: "col-6",
                          arr: [
                            {
                              title: "Project Description",
                              field: "ProjectDescription",
                              type: "textarea",
                              className: "col-12",
                            },
                            {
                              title: "Project Sq. Ft.",
                              field: "projectSqFt",
                              type: "text",
                              className: "col-12",
                            },
                            {
                              title: "Completion Date",
                              field: "completionDate",
                              type: "date",
                              className: "col-12",
                            },
                            {
                              title: "Joint Check",
                              field: "jointCheck",
                              type: "checkbox",
                              className: "col-6",
                            },

                            {
                              title: "Revolving",
                              field: "revolving",
                              type: "checkbox",
                              className: "col-6",
                            },
                          ],
                        },
                        {
                          section: "Funding",
                          className: "col-6",
                          arr: [
                            {
                              title: "Available Fund",
                              type: "text",
                              field: "availableFund",
                              className: "col-12",
                            },
                          ],
                        },
                        {
                          section: "Contractor Information",
                          className: "col-12",
                          arr: [
                            // {
                            //   title: "Name & Address",
                            //   type: "textarea",
                            //   field: "nameAndAddress",
                            //   className: "col-12",
                            // },
                            {
                              title: "License No.",
                              type: "text",
                              field: "licenseNo",
                              className: "col-12",
                            },
                          ],
                        },
                      ],
                    },
                    {
                      subArrtitle: "Billing",
                      subArrarr: [
                        {
                          section: "Billing Cycle",
                          className: "col-6",
                          arr: [
                            {
                              title: "Calculation Method",
                              field: "CalculationMethod",
                              type: "select",
                              options: [
                                {
                                  value: "Average Balance",
                                  label: "Average Balance",
                                },
                                {
                                  value: "Lowest Balance",
                                  label: "Lowest Balance",
                                },
                                {
                                  value: "Highest Balance",
                                  label: "Highest Balance",
                                },
                                {
                                  value: "Daily Balance",
                                  label: "Daily Balance",
                                },
                              ],
                              className: "col-12",
                            },
                            {
                              title: "Billing Frequency",
                              field: "BillingFrequency",
                              type: "select",
                              options: [
                                { value: "Quarterly", label: "Quarterly" },
                                { value: "Semi-Yearly", label: "Semi-Yearly" },
                                { value: "Yearly", label: "Yearly" },
                                { value: "Monthly", label: "Monthly" },
                              ],
                              className: "col-12",
                            },
                            {
                              title: "Loc Billed To Date",
                              type: "date",
                              field: "LocBilledtodate",
                              className: "col-12",
                            },
                            {
                              title: "Start Day",
                              field: "StartDay",
                              type: "select",
                              options: [
                                { label: "1", value: 1 },
                                { label: "2", value: 2 },
                                { label: "3", value: 3 },
                                { label: "4", value: 4 },
                                { label: "5", value: 5 },
                                { label: "6", value: 6 },
                                { label: "7", value: 7 },
                                { label: "8", value: 8 },
                                { label: "9", value: 9 },
                                { label: "10", value: 10 },
                                { label: "11", value: 11 },
                                { label: "12", value: 12 },
                                { label: "13", value: 13 },
                                { label: "14", value: 14 },
                                { label: "15", value: 15 },
                                { label: "16", value: 16 },
                                { label: "17", value: 17 },
                                { label: "18", value: 18 },
                                { label: "19", value: 19 },
                                { label: "20", value: 20 },
                                { label: "21", value: 21 },
                                { label: "22", value: 22 },
                                { label: "23", value: 23 },
                                { label: "24", value: 24 },
                                { label: "25", value: 25 },
                                { label: "26", value: 26 },
                                { label: "27", value: 27 },
                                { label: "28", value: 28 },
                                { label: "29", value: 29 },
                                { label: "30", value: 30 },
                                { label: "31", value: 31 },
                              ],
                              className: "col-12",
                            },
                          ],
                        },
                        {
                          section: "Account Maintenance Fee",
                          className: "col-6",
                          arr: [
                            {
                              title: "Maintenance Fee",
                              type: "text",
                              field: "MaintenanceFee",
                              className: "col-12",
                            },
                            {
                              title: "Next Charge Date",
                              type: "date",
                              field: "NextChargeDate",
                              className: "col-12",
                            },
                            {
                              title: "Frequency",
                              field: "Frequency",
                              type: "select",
                              options: [
                                { value: "Quarterly", label: "Quarterly" },
                                { value: "Semi-Yearly", label: "Semi-Yearly" },
                                { value: "Yearly", label: "Yearly" },
                                { value: "Monthly", label: "Monthly" },
                              ],
                              className: "col-12",
                            },
                            {
                              title: "Access Finance Charge",
                              field: "AccessFinanceCharge",
                              type: "checkbox",
                              className: "col-12",
                            },
                          ],
                        },
                        {
                          section: "Interest Charge Calculation",
                          className: "col-6",
                          arr: [
                            {
                              title: "Exclude Late Charges/NSFa",
                              type: "checkbox",
                              field: "ExcludeLateCharges/NSFa",
                              className: "col-12",
                            },
                            {
                              title: "Exclude Reserve Balances",
                              type: "checkbox",
                              field: "ExcludeReserveBalances",
                              className: "col-12",
                            },
                            {
                              title: "Exclude Impound Balances",
                              type: "checkbox",
                              field: "ExcludeImpoundBalances",
                              className: "col-12",
                            },
                            {
                              title: "Exclude Finance Charges",
                              type: "checkbox",
                              field: "ExcludeFinanceCharges",
                              className: "col-12",
                            },
                          ],
                        },
                        {
                          section: "Interest Charge Calculation",
                          className: "col-6",
                          arr: [
                            {
                              title: "Percent Of Draw",
                              type: "text",
                              field: "PercentOfDraw",
                              className: "col-12",
                            },
                            {
                              title: "Plus Flat Amount",
                              type: "text",
                              field: "PlusFlatAmount",
                              className: "col-12",
                            },
                            {
                              title: "Minimum Fee",
                              type: "text",
                              field: "MinimumFee",
                              className: "col-12",
                            },
                          ],
                        },
                        {
                          section: "Auto Payment from Reserve",
                          className: "col-6",
                          arr: [
                            {
                              title: "Percent Of Amount Due",
                              type: "text",
                              field: "PercentOfAmountDue",
                              className: "col-12",
                            },
                            {
                              title: "Plus Flat Amount",
                              type: "text",
                              field: "PlusFlatAmount",
                              className: "col-12",
                            },
                            {
                              title: "If insufficient Funds in Reserve",
                              field: "IfinsufficientFundsinReserve",
                              type: "select",
                              className: "col-12",
                              options: [
                                { value: "Do not pay", label: "Do not pay" },
                                {
                                  value: "Pay full amount",
                                  label: "Pay full amount",
                                },
                                {
                                  value: "Pay available amount",
                                  label: "Pay available amount",
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              subArrtitle: "ARM",
              subArrarr: [
                {
                  section: "",
                  className: "col-12",
                  arr: [
                    {
                      title: "ARM Index",
                      field: "armIndex",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Index Rate",
                      field: "armIndexRate",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Margin",
                      field: "armMargin",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Ceiling",
                      field: "armCeiling",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Floor",
                      field: "armFloor",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Rate First Change Active",
                      field: "armRateFirstChangeActive",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Rate First Change Minimum Cap",
                      field: "armRateFirstChangeMinCap",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Rate First Change Maximum Cap",
                      field: "armRateFirstChangeMaxCap",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Rate Periodic Minimum Cap",
                      field: "armRatePeriodicMinCap",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Rate Periodic Maximum Cap",
                      field: "armRatePeriodicMaxCap",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Rate Change Frequency",
                      field: "armRateChangeFrequency",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Rate Change Next",
                      field: "armRateChangeNext",
                      type: "date",
                      className: "col-4",
                    },
                    {
                      title: "ARM Rate Rounding",
                      field: "armRateRounding",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Rate Round Factor",
                      field: "armRateRoundFactor",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Send Rate Change Notice",
                      field: "armSendRateChangeNotice",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Notice Lead Days",
                      field: "armNoticeLeadDays",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Carry Over Enabled",
                      field: "armCarryOverEnabled",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Carry Over Amount",
                      field: "armCarryOverAmount",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Look Back Days",
                      field: "armLookBackDays",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Payment Adjustment",
                      field: "armPaymentAdjustment",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Payment Cap",
                      field: "armPaymentCap",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Payment Change Frequency",
                      field: "armPaymentChangeFrequency",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Payment Change Next",
                      field: "armPaymentChangeNext",
                      type: "date",
                      className: "col-4",
                    },
                    {
                      title: "ARM Negamort Cap",
                      field: "armNegamortCap",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Recast Payment",
                      field: "armRecastPayment",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Recast Frequency",
                      field: "armRecastFrequency",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM Recast Next Date",
                      field: "armRecastNextDate",
                      type: "date",
                      className: "col-4",
                    },
                    {
                      title: "ARM Recast Stop Date",
                      field: "armRecastStopDate",
                      type: "date",
                      className: "col-4",
                    },
                    {
                      title: "ARM Recast To Date",
                      field: "armRecastToDate",
                      type: "date",
                      className: "col-4",
                    },
                    {
                      title: "ARM User Recast To Date",
                      field: "armUserRecastToDate",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM ISO Ptionarm",
                      field: "armIsoPtionarm",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      title: "ARM First Notice Date",
                      field: "armFirstNoticeDate",
                      type: "date",
                      className: "col-4",
                    },
                  ],
                },
              ],
            },
            {
              subArrtitle: "Penalties",
              subArrarr: [
                {
                  section: "Late Charge",
                  className: "col-6",
                  arr: [
                    {
                      title: "Late Charge Method",
                      field: "lateChargeMethod",
                      type: "select",
                      options: [{ value: "Default", label: "Default" }],
                      className: "col-6",
                    },
                    {
                      title: "Number of Grace Days",
                      field: "numberOfGraceDays",
                      type: "text",
                      className: "col-6",
                    },
                    {
                      title: "Grace Days Method",
                      field: "graceDaysMethod",
                      type: "text",
                      className: "col-6",
                    },
                    {
                      title: "Late Charge Minimum",
                      field: "lateChargeMinimum",
                      type: "text",
                      className: "col-6",
                    },
                    {
                      title: "Percentage Of",
                      field: "percentageOf",
                      type: "select",
                      options: [
                        { value: "P & I", label: "P & I" },
                        { value: "Total Pmt", label: "Total Pmt" },
                      ],
                      className: "col-6",
                    },
                    {
                      title: "Late Charge Percentage",
                      field: "lateChargePercentage",
                      type: "text",
                      className: "col-6",
                    },
                    {
                      title: "Additional Daily Amount",
                      field: "additionalDailyAmount",
                      type: "text",
                      className: "col-6",
                    },
                    {
                      title: "Distribution of Lender",
                      field: "distributionOfLender",
                      type: "text",
                      className: "col-6",
                    },
                    {
                      title: "Late Charge Vendor Percentage",
                      field: "lateChargeVendorPercentage",
                      type: "text",
                      className: "col-6",
                    },
                  ],
                },
                {
                  section: "Prepayment Penalty",
                  className: "col-6",
                  arr: [
                    {
                      content: "If you close your line of credit within",
                      type: "content",
                      className: "col-6 d-flex align-items-center",
                    },
                    {
                      title: "",
                      field: "PrepaymentPenaltyMonths",
                      type: "text",
                      className: "col-4",
                    },
                    {
                      content: "months of",
                      type: "content",
                      className: "col-2 d-flex align-items-center",
                    },
                    {
                      content: "agreement you'll be required to pay a fee of",
                      type: "content",
                      className: "col-8 d-flex align-items-center",
                    },
                    {
                      title: "",
                      field: "PrepaymentPenaltyFee",
                      type: "text",
                      className: "col-4",
                    },
                  ],
                },
                {
                  section: "Prepayment Penalty",
                  className: "col-6",
                  arr: [
                    {
                      title: "Default Rate After Value",
                      field: "defaultRateAfterValue",
                      type: "number",
                      className: "col-6",
                    },
                    {
                      title: "Default Rate After",
                      field: "defaultRateAfter",
                      type: "select",
                      options: [
                        { value: "Days", label: "Days" },
                        { value: "Months", label: "Months" },
                      ],
                      className: "col-6",
                    },
                    {
                      title: "Default Rate Until",
                      field: "defaultRateUntil",
                      type: "select",
                      options: [
                        { value: "Current", label: "Current" },
                        { value: "Maturity", label: "Maturity" },
                      ],
                      className: "col-12",
                    },
                    {
                      title: "Default Rate Method",
                      field: "defaultRateMethod",
                      type: "select",
                      options: [
                        { value: "Fixed Rate", label: "Fixed Rate" },
                        { value: "Modifier", label: "Modifier" },
                      ],
                      className: "col-12",
                    },
                    {
                      title: "Default Rate Value",
                      field: "defaultRateValue",
                      type: "number",
                      className: "col-12",
                    },
                    {
                      title: "Default Rate Lender Percentage",
                      field: "defaultRateLenderPercentage",
                      type: "number",
                      className: "col-12",
                    },
                    {
                      title: "Default Rate Vendor Percentage",
                      field: "defaultRateVendorPercentage",
                      type: "number",
                      className: "col-12",
                    },
                  ],
                },
                {
                  section: "Prepayment Penalty Expiration & Distribution",
                  className: "col-6",
                  arr: [
                    {
                      title: "Prepayment Penalty Expires",
                      field: "prepaymentPenaltyExpires",
                      type: "date",
                      className: "col-12",
                    },
                    {
                      title: "Distribute to Lenders",
                      field: "distributeToLenders",
                      type: "number",
                      className: "col-12",
                    },
                    {
                      title: "Distribute to Orig. Vendor",
                      field: "distributeToOrigVendor",
                      type: "number",
                      className: "col-12",
                    },
                  ],
                },
              ],
            },
            {
              subArrtitle: "Options",
              subArrarr: [
                {
                  section: "Loan, Amortization & Rate Type",
                  className: "col-6",
                  arr: [
                    {
                      title: "Loan Type",
                      field: "loanType",
                      type: "select",
                      options: [
                        { value: "Construction", label: "Construction" },
                        { value: "Conventional", label: "Conventional" },
                        { value: "Line of Credit", label: "Line of Credit" },
                        { value: "Other", label: "Other" },
                      ],
                      className: "col-12",
                    },
                    {
                      title: "Amortization Type",
                      field: "amortType",
                      type: "select",
                      options: [
                        {
                          value: "FAM - Fully Amortized",
                          label: "FAM - Fully Amortized",
                        },
                        {
                          value: "PAM - Partially Amortized",
                          label: "PAM - Partially Amortized",
                        },
                        {
                          value: "IOM - Interest Only",
                          label: "IOM - Interest Only",
                        },
                        {
                          value: "CAM - Constant Amortization",
                          label: "CAM - Constant Amortization",
                        },
                        {
                          value: "ADD - Add-On Interest",
                          label: "ADD - Add-On Interest",
                        },
                        { value: "Other", label: "Other" },
                      ],
                      className: "col-12",
                    },
                    {
                      title: "Rate Type",
                      field: "rateType",
                      type: "select",
                      options: [
                        {
                          value: "FRM - Fixed Rate",
                          label: "FRM - Fixed Rate",
                        },
                        {
                          value: "ARM - Adjustable Rate",
                          label: "ARM - Adjustable Rate",
                        },
                        {
                          value: "GTM - Graduated Terms",
                          label: "GTM - Graduated Terms",
                        },
                      ],
                      className: "col-12",
                    },
                  ],
                },
                {
                  section: "Periodic Interest Accrual Method",
                  className: "col-6",
                  arr: [
                    {
                      title: "Periodic Interest Accrual Method",
                      field: "periodicInterestAccrualMethod",
                      type: "radio",
                      options: [
                        {
                          value: "Regular Period (Due Date to Due Date)",
                          title: "Regular Period (Due Date to Due Date)",
                        },
                        {
                          value: "Actual Days (Due Date to Due Date)",
                          title: "Actual Days (Due Date to Due Date)",
                        },
                        {
                          value: "Actual Days (Received Date to Received Date)",
                          title: "Actual Days (Received Date to Received Date)",
                        },
                      ],
                      className: "col-12",
                    },
                    {
                      title: "Use Canadian Amortization",
                      field: "useCanadianAmortization",
                      type: "checkbox",
                      className: "col-12",
                    },
                  ],
                },
                {
                  section: "Add Negative Amortization To",
                  className: "col-6",
                  arr: [
                    {
                      title: "Add Negative Amortization To",
                      field: "addNegativeAmortizationTo",
                      type: "radio",
                      options: [
                        {
                          value: "Principal Balance",
                          title: "Principal Balance",
                        },
                        { value: "Unpaid Interest", title: "Unpaid Interest" },
                      ],
                      className: "col-12",
                    },
                  ],
                },
                {
                  section: "Calculate Daily Rate Using",
                  className: "col-6",
                  arr: [
                    {
                      title: "Calculate Daily Rate Using",
                      field: "calculateDailyRateUsing",
                      type: "radio",
                      options: [
                        {
                          value: "360 Days Year Basis",
                          title: "360 Days Year Basis",
                        },
                        {
                          value: "365 Days Year Basis",
                          title: "365 Days Year Basis",
                        },
                      ],
                      className: "col-12",
                    },
                  ],
                },
                {
                  section: "Unpaid Interest Handling",
                  className: "col-6",
                  arr: [
                    {
                      title: "Include When Calculating Interest",
                      field: "IncludeWhenCalculatingInterest",
                      type: "checkbox",
                      className: "col-12",
                    },
                    {
                      title: "Pay Automatically",
                      field: "PayAutomatically",
                      type: "checkbox",
                      className: "col-12",
                    },
                  ],
                },
                {
                  section: "Calculate Days Between Dates Using",
                  className: "col-6",
                  arr: [
                    {
                      title: "Calculate Days Between Dates Using",
                      field: "calculateDaysBetweenDatesUsing",
                      type: "radio",
                      options: [
                        {
                          value: "30 Day Month Basis",
                          title: "30 Day Month Basis",
                        },
                        {
                          value: "Actual Number of Days",
                          title: "Actual Number of Days",
                        },
                      ],
                      className: "col-12",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ];
};
